import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ShopItemReward')
export class ShopItemReward {

  @JsonProperty('currency_type', Number)
  currencyType: number = 0;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;

  @JsonProperty('currency_increase_percent', Number)
  currencyIncreasePercent: number = 0;
}
